// Shared state to prevent VOI update infinite loops
// This is separate to avoid circular dependencies between settings.ts and listeners.ts

let isProgrammaticVOIChange = false;

export function setProgrammaticVOIChange(value: boolean) {
  isProgrammaticVOIChange = value;
}

export function isProgrammaticVOI(): boolean {
  return isProgrammaticVOIChange;
}
